import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AgeConfig } from '../config';
import { ApiServicesService } from '../services/api-services.service';
import { UserDetailsService } from '../services/user-details.service';
@Component({
  selector: 'app-filter',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule,
    MatSelectModule, MatCheckboxModule, MatButtonModule],
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent {
  form: FormGroup;
  Countryoption: any = [];
  states: any = [];
  cities: any = [];
  ageOptions = AgeConfig.ageOptions;
  filteredAgeOptions: number[] = this.ageOptions;
  genderOptions: any = [];
  isVisible: boolean = false;
  selectedCountry: string | null = null;
  @Output() closeOverlay = new EventEmitter<void>();
  @Output() memberdata = new EventEmitter<void>();
  submittedData: any;
  selectedCountryId: any;
  selectedStateId: any;
  constructor(private fb: FormBuilder, private api: ApiServicesService, private userdetails: UserDetailsService) {
    this.form = this.fb.group({
      country: [''],
      state: [''],
      city: [''],
      gender: [''],
      ageFrom: [''],
      ageTo: [''],
    });
  }

  ngOnInit() {
    this.userdetails.dropDownData$.subscribe((dropDownData) => {
      if (dropDownData) {
        this.genderOptions = dropDownData.genders;
        this.Countryoption = dropDownData.countries;
      }
      console.log('dropDownData',dropDownData)
    });
  }

  // Handle change in selected country
  onCountryChange(countryId: any) {
    this.selectedCountryId = countryId;
    if (this.selectedCountryId) {
      this.loadStatesByCountry(this.selectedCountryId);
    }
  }

  // Load states based on selected country
  loadStatesByCountry(countryId: any) {
    this.api.getStatesByCountry(countryId).subscribe((response: any) => {
      this.states = response?.data || [];

      
      if (!response?.data?.states || response.data.states.length === 0) {
        this.cities = response?.data?.cities || [];
        this.states = [];
      } else {
        this.states = response?.data?.states || [];
      }
      // Reset the state and city fields in the form
       this.form.patchValue({
        city:'',
        state:'',
      })
    });
  }
  // Handle change in selected state
  onStateChange(stateId: any) {
    this.selectedStateId = stateId;  // Store selected state ID
    if (this.selectedStateId) {
      this.loadCitiesByState(this.selectedStateId);
    }
  }

  // Load cities based on selected state
  loadCitiesByState(stateId: any) {
    this.api.getCity(stateId).subscribe((response: any) => {
      this.cities = response?.data || [];
    });
  }

  open() {
    this.isVisible = true;
    const dropdownData = localStorage.getItem("filterDropdowndata");
    if (!dropdownData) {
      this.api.filterDropdowndata().subscribe({
        next: (response: any) => {
          this.genderOptions = response.data.genders;
          // console.log('gender-opions',this.genderOptions)
        this.Countryoption = response.data.countries;
          localStorage.setItem("filterDropdowndata", JSON.stringify(response.data));
        },
        error: (err) => {
          console.error('Error fetching states:', err);
        }
      });
    }else{
      const parsedData = JSON.parse(dropdownData);
      this.genderOptions = parsedData.genders;
      this.Countryoption = parsedData.countries;
    }


    if (this.savedGender) {
      this.form.patchValue(this.savedGender);
      // console.log('saveedgender',this.savedGender._id)
    }
    

  
  }

  savedFilters:any;
  close() {
    this.isVisible = false;
    this.savedFilters = this.form.value;
    // console.log('savedGender',this.savedGender)

  }

  savedGender:any
  apply(): void {
    this.isVisible = false;
    if (this.form.valid) {
      this.memberdata.emit(this.form.value);
    }
    this.savedGender = this.form.value.gender;
    // console.log('this.savedGender',this.savedGender)
  }
  updateAgeToOptions(): void {
    const selectedAgeFrom = this.form.get('ageFrom')?.value;
    this.filteredAgeOptions = this.ageOptions.filter(age => age > selectedAgeFrom && age <= 90);
    this.form.patchValue({
      ageTo:'',
    })
  }
  clearForm() {
    this.form.patchValue({
      country:'',
      state:'',
      city:'',
      gender:'',
      ageFrom:'',
      ageTo:'',
    })
    // this.memberdata.emit({});
  }
}
